import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { GraphQLComparision } from "../../../enums/GraphQLComparision.enum";
import { Multi } from "../../../interfaces/multi.interface";
import { GraphQlQueryResult } from "../query-executor/graphql-query-executor.operator";


export function GraphQlQueryResultToNgxMulti(): OperatorFunction<GraphQlQueryResult, Multi[]> {

  return map(graphQlQueryResult => {

    const query = graphQlQueryResult.graphQlQuery;
    const result = graphQlQueryResult.result;


    const data = Object.entries(result.data[query.dataset].items.map(i => {

      const nameSelect = query.groupBys[0].path;
      const name = i[nameSelect];

      return ({
        seriesKey: query.groupBys.slice(1).map(g => i[g.path]).join(", "),
        wheres: query.groupBys.map(g => {


          if (g.timeUnit != null) {

            var from = new Date(i[g.path]);
            var to = new Date(i[g.path]);

            if (g.timeUnit == "HOURS") to.setHours(from.getHours() + 1);
            else if (g.timeUnit == "DAYS") to.setDate(from.getDate() + 1);
            else throw "Failed";

            return [
              { path: g.path, comparison: GraphQLComparision.GREATER_THAN_OR_EQUAL, value: "" + i[g.path] },
              { path: g.path, comparison: GraphQLComparision.LESS_THAN, value: "" + to.toJSON() }
            ]
          }


          return [{ path: g.path, comparison: GraphQLComparision.EQUAL, value: i[g.path] }];
        }).flat(),
        "name": "" + name,
        "value": i[query.selects[0].field],
        "data": i,
        "query": query
      });
    }).groupBy(r => r.seriesKey)).sort((a, b) => a[0].localeCompare(b[0])).map(e => {

      const name = e[0];
      return {
        name: name,
        series: (<[{ name, value }]>e[1]).sort((a, b) => a.name.localeCompare(b.name)).map(r => Object.assign({}, r, { name: isDate(r.name) ? new Date(r.name) : r.name })).sort((a, b) => (a.name < b.name) ? -1 : 1)
      }
    });
    //
    return data;
  });
}


const dateRegex = new RegExp('^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d{1,3}|)Z$')
var isDate = function (str) {
  return dateRegex.test(str);
}
